import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { Company, Job, FirmWorkflow } from '../types/index'
import { SfLog } from '@app/adapters/logger'
import api from '@app/insights/api'

export const useBulkActionsStore = defineStore('bulkActions', () => {
  const jobs = ref<Job[]>([])
  const nonActionableCompanies = ref<Company[]>([])
  const selectedWorkflow = ref<FirmWorkflow | null>(null)

  const isActionRunning = computed(() =>
    jobs.value.some((job) => job.running && !job.finished)
  )

  const actionsInProgress = computed(() =>
    jobs.value.filter((job) => job.running && !job.finished)
  )

  function setActionStatus(status: Job): void {
    const index = jobs.value.findIndex(
      (job) => job.insight_action_run_id === status.insight_action_run_id
    )
    if (index !== -1) {
      jobs.value.splice(index, 1, { ...jobs.value[index], ...status })
    } else {
      jobs.value.push(status)
    }
  }

  async function fetchNonActionableCompanies(
    actionName: string,
    companyIds: [],
    payload: Record<string, unknown>
  ): Promise<void> {
    const data: Company[] = (await api.fetchNonActionableCompanies({
      actionName,
      companyIds,
      payload,
    })) as Company[]
    if (data) {
      nonActionableCompanies.value = data
    } else {
      SfLog.info('Failed to fetch non-actionable companies', {
        extra: {
          actionName,
          payload,
        },
      })
    }
  }

  function setSelectedWorkflow(fwf: FirmWorkflow): void {
    selectedWorkflow.value = fwf
  }

  return {
    jobs,
    isActionRunning,
    actionsInProgress,
    setActionStatus,
    nonActionableCompanies,
    fetchNonActionableCompanies,
    selectedWorkflow,
    setSelectedWorkflow,
  }
})
